import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "filter-select" }
const _hoisted_2 = {
  key: 0,
  class: "filter-select__placeholder"
}
const _hoisted_3 = {
  key: 1,
  class: "filter-select__label-content"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "filter-select__content" }
const _hoisted_7 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _mergeProps({ class: "filter-select__input-area d-flex justify-content-between align-items-center" }, _toHandlers(_ctx.eventList, true), { "data-test-id": "filter-select__button" }), [
      (_ctx.labelsSelected.length == 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.placeholder), 1))
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelsSelected.slice(0, 3), (label, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "filter-select__label-item"
              }, _toDisplayString(_ctx.formatString(label)), 1))
            }), 128))
          ])), [
            [
              _directive_tooltip,
              _ctx.formatterTooltip,
              void 0,
              { top: true }
            ]
          ]),
      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon-nav-bullet_down" }, null, -1))
    ], 16),
    (_ctx.showSelectOptions)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "filterSelectOptions",
          class: "filter-select__options-list",
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveSelectOptions && _ctx.mouseLeaveSelectOptions(...args))),
          onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseEnterSelectOptions && _ctx.mouseEnterSelectOptions(...args)))
        }, [
          _createElementVNode("div", {
            class: "filter-select__input-area d-flex justify-content-between align-items-center mb-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSelect()))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "filter-select__placeholder-list" }, "FILTRAR POR", -1),
            _createElementVNode("i", { class: "icon-nav-bullet_up" }, null, -1)
          ])),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.options), (keyName, index) => {
            return (_openBlock(), _createElementBlock("details", {
              key: index,
              id: `details-${index}`,
              class: "filter-select__details-header"
            }, [
              _createElementVNode("summary", {
                onClick: ($event: any) => (_ctx.toggleDetails(index)),
                "data-test-id": "filter-select__summary"
              }, [
                _createTextVNode(_toDisplayString(keyName) + " ", 1),
                _createElementVNode("i", {
                  class: _normalizeClass(
                _ctx.isOpen[index] ? 'icon-nav-bullet_up' : 'icon-nav-bullet_down'
              )
                }, null, 2)
              ], 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options[keyName], (item, index_item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index_item,
                    class: "d-flex align-items-center justify-content-between filter-select__item",
                    "data-test-id": "filter-select__option"
                  }, [
                    _createElementVNode("label", {
                      for: item.value
                    }, _toDisplayString(item.label), 9, _hoisted_7),
                    _createVNode(_component_Checkbox, {
                      name: "options",
                      role: "checkbox",
                      inputId: item.value,
                      modelValue: _ctx.selectedData[keyName],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.selectedData[keyName]) = $event),
                      value: item,
                      "data-test-id": "filter-select__checkbox"
                    }, null, 8, ["inputId", "modelValue", "onUpdate:modelValue", "value"])
                  ]))
                }), 128))
              ])
            ], 8, _hoisted_4))
          }), 128))
        ], 544))
      : _createCommentVNode("", true)
  ]))
}